import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static classes = ['visible', 'hidden']

  declare readonly visibleClasses: string[]
  declare readonly hiddenClasses: string[]

  private showTimeoutId?: ReturnType<typeof setTimeout>
  private removeTimeoutId?: ReturnType<typeof setTimeout>

  connect(): void {
    this.showTimeoutId = setTimeout(() => this.show(), 300)
  }

  disconnect(): void {
    if (this.showTimeoutId) {
      clearTimeout(this.showTimeoutId)
    }
    if (this.removeTimeoutId) {
      clearTimeout(this.removeTimeoutId)
    }
  }

  close(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.hide()
  }

  show(): void {
    this.element.classList.remove(...this.hiddenClasses)
    this.element.classList.add(...this.visibleClasses)
  }

  hide(): void {
    this.element.classList.remove(...this.visibleClasses)
    this.element.classList.add(...this.hiddenClasses)

    this.removeTimeoutId = setTimeout(() => {
      this.element.remove()
    }, 500)
  }
}
